import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";

import EmptyState from "../../crmpostventa-shared/components/EmptyState";
import { ULTIMOS_CAMBIOS } from "../fichaFormat";
import HistorialCambios from "./HistorialCambios";

const subtitleOf = (count) => {
  if (!count) return "Cambios de esta terminal, campo por campo.";
  return count === 1 ? "El último cambio de esta terminal." : `Los últimos ${count} cambios de esta terminal.`;
};

/**
 * History summary of the Ficha (design Prompt 1, point 4): the last 5 changes of this terminal and "Ver historial
 * completo" (onVerHistorial with no block), or the EmptyState when the terminal has no changes.
 */
export default function HistorialResumen({ items, onVerHistorial, ...props }) {
  const shown = (Array.isArray(items) ? items : []).slice(0, ULTIMOS_CAMBIOS);

  return (
    <section className="crm-ficha__hist" aria-labelledby="crm-ficha-hist-title">
      <div className="crm-ficha__hist-head">
        <div>
          <h4 id="crm-ficha-hist-title">Historial de cambios</h4>
          <p className="crm-rollo__desc">{subtitleOf(shown.length)}</p>
        </div>
        {shown.length ? (
          <button type="button" className="crm-rollo__btn crm-rollo__btn--secondary crm-rollo__btn--sm" onClick={() => onVerHistorial?.()}>
            <FontAwesomeIcon icon={faClockRotateLeft} aria-hidden="true" />
            Ver historial completo
          </button>
        ) : null}
      </div>
      {shown.length ? (
        <HistorialCambios items={shown} {...props} />
      ) : (
        <EmptyState
          icon={faClockRotateLeft}
          title="Todavía no hay cambios registrados en esta terminal"
          text="Cuando alguien modifique sus datos, cada campo queda acá con quién, cuándo, el motivo y de dónde vino."
        />
      )}
    </section>
  );
}
